import React from 'react';

export default function NotFound() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      fontFamily: 'sans-serif',
      color: '#333',
      zIndex: 9999,
    }}>
      <h1 style={{ fontSize: '4rem', margin: 0 }}>404</h1>
      <h2 style={{ fontSize: '1.5rem', margin: '8px 0' }}>Not Found</h2>
      <p style={{ color: '#666' }}>The page you're looking for doesn't exist.</p>
    </div>
  );
}
